export const BIND_SALE_NO_REQUEST = 'BIND_SALE_NO_REQUEST';
export const BIND_SALE_NO_SUCCESS = 'BIND_SALE_NO_SUCCESS';
export const BIND_SALE_NO_FAILURE = 'BIND_SALE_NO_FAILURE';

export const BIND_AUCTIONDATA_REQUEST = 'BIND_AUCTIONDATA_REQUEST';
export const BIND_AUCTIONDATA_SUCCESS = 'BIND_AUCTIONDATA_SUCCESS';
export const BIND_AUCTIONDATA_FAILURE = 'BIND_AUCTIONDATA_FAILURE';

export const BIND_LOATNO_REQUEST = 'BIND_LOATNO_REQUEST';
export const BIND_LOATNO_SUCCESS = 'BIND_LOATNO_SUCCESS';
export const BIND_LOATNO_FAILURE = 'BIND_LOATNO_FAILURE';

export const BIND_SESSIONTIME_REQUEST = 'BIND_SESSIONTIME_REQUEST';
export const BIND_SESSIONTIME_SUCCESS = 'BIND_SESSIONTIME_SUCCESS';
export const BIND_SESSIONTIME_FAILURE = 'BIND_SESSIONTIME_FAILURE';


export const BIND_AUCTIONEER_REQUEST = 'BIND_AUCTIONEER_REQUEST';
export const BIND_AUCTIONEER_SUCCESS = 'BIND_AUCTIONEER_SUCCESS';
export const BIND_AUCTIONEER_FAILURE = 'BIND_AUCTIONEER_FAILURE';

// actions.js
export const DOWNLOAD_EXCEL_REQUEST = 'DOWNLOAD_EXCEL_REQUEST';
export const DOWNLOAD_EXCEL_SUCCESS = 'DOWNLOAD_EXCEL_SUCCESS';
export const DOWNLOAD_EXCEL_FAILURE = 'DOWNLOAD_EXCEL_FAILURE';

export const DOWNLOAD_PDF_REQUEST = 'DOWNLOAD_PDF_REQUEST';
export const DOWNLOAD_PDF_SUCCESS = 'DOWNLOAD_PDF_SUCCESS';
export const DOWNLOAD_PDF_FAILURE = 'DOWNLOAD_PDF_FAILURE';

export const DOWNLOAD_AUCTIONEER_PDF_REQUEST = 'DOWNLOAD_AUCTIONEER_PDF_REQUEST';
export const DOWNLOAD_AUCTIONEER_PDF_SUCCESS = 'DOWNLOAD_AUCTIONEER_PDF_SUCCESS';
export const DOWNLOAD_AUCTIONEER_PDF_FAILURE = 'DOWNLOAD_AUCTIONEER_PDF_FAILURE';

export const DOWNLOAD_AUCTIONEER_EXCEL_REQUEST = 'DOWNLOAD_AUCTIONEER_EXCEL_REQUEST';
export const DOWNLOAD_AUCTIONEER_EXCEL_SUCCESS = 'DOWNLOAD_AUCTIONEER_EXCEL_SUCCESS';
export const DOWNLOAD_AUCTIONEER_EXCEL_FAILURE = 'DOWNLOAD_AUCTIONEER_PDF_FAILURE';

export const DOWNLOAD_TAO_EXCEL_REQUEST = 'DOWNLOAD_TAO_EXCEL_REQUEST';
export const DOWNLOAD_TAO_EXCEL_SUCCESS = 'DOWNLOAD_TAO_EXCEL_SUCCESS';
export const DOWNLOAD_TAO_EXCEL_FAILURE = 'DOWNLOAD_TAO_EXCEL_FAILURE';

export const DOWNLOAD_TAO_PDF_REQUEST = 'DOWNLOAD_TAO_PDF_REQUEST';
export const DOWNLOAD_TAO_PDF_SUCCESS = 'DOWNLOAD_TAO_PDF_SUCCESS';
export const DOWNLOAD_TAO_PDF_FAILURE = 'DOWNLOAD_TAO_PDF_FAILURE';


export const VIEWDEALBOOK_SEARCH_REQUEST = 'VIEWDEALBOOK_SEARCH_REQUEST';
export const VIEWDEALBOOK_SEARCH_SUCCESS = 'VIEWDEALBOOK_SEARCH_SUCCESS';
export const VIEWDEALBOOK_SEARCH_FAILURE = 'VIEWDEALBOOK_SEARCH_FAILURE';


export const VIEWDEALBOOK_LIST_REQUEST = 'VIEWDEALBOOK_LIST_REQUEST';
export const VIEWDEALBOOK_LIST_SUCCESS = 'VIEWDEALBOOK_LIST_SUCCESS';
export const VIEWDEALBOOK_LIST_FAILURE = 'VIEWDEALBOOK_LIST_FAILURE';


export const VIEW_DEALBOOK_LIST_REQUEST = "VIEW_DEALBOOK_LIST_REQUEST";
export const VIEW_DEALBOOK_LIST_SUCCESS = "VIEW_DEALBOOK_LIST_SUCCESS";
export const VIEW_DEALBOOK_LIST_FAILURE = "VIEW_DEALBOOK_LIST_FAILURE";